import axiosInstance from './axiosInstance';

/**
 * Mailbox (admin) — outreach email sent and received as sameer@servpatch.co.uk.
 * See api/controllers/admin/outreach.controller.js.
 */

export const fetchOutreachTemplates = async () => {
  const res = await axiosInstance.get('/admin/outreach/templates');
  return res.data;
};

/** Server returns { data, stats: { open, archived, spam, unread }, pagination }. */
export const fetchOutreachThreads = async (params = {}) => {
  const res = await axiosInstance.get('/admin/outreach/threads', { params });
  return res.data;
};

/** Opening a conversation also marks it read. */
export const fetchOutreachThread = async (id) => {
  const res = await axiosInstance.get(`/admin/outreach/threads/${id}`);
  return res.data;
};

/** changes: { status?: 'open'|'archived'|'spam', unread?: boolean } */
export const updateOutreachThread = async (id, changes) => {
  const res = await axiosInstance.patch(`/admin/outreach/threads/${id}`, changes);
  return res.data;
};

/** payload: { templateKey, toEmail, toName, subject, body } or { threadId, toEmail, body } */
export const previewOutreachEmail = async (payload) => {
  const res = await axiosInstance.post('/admin/outreach/preview', payload);
  return res.data;
};

/** payload: { toEmail, toName, templateKey, subject, body } */
export const sendOutreachEmail = async (payload) => {
  const res = await axiosInstance.post('/admin/outreach/send', payload);
  return res.data;
};

export const replyToOutreachThread = async (id, body) => {
  const res = await axiosInstance.post(`/admin/outreach/threads/${id}/reply`, { body });
  return res.data;
};

export const allowOutreachEmailsAgain = async (email) => {
  const res = await axiosInstance.delete('/admin/outreach/suppressions', { params: { email } });
  return res.data;
};
